// All or portions of this file Copyright © 2019 Amazon Web Services, Inc. or its affiliates or licensors.
// All rights reserved. For full license terms and conditions, please see the LICENSE file at the root of
// this distribution (the "License") or go to https://content.sumerian.amazonaws.com/engine/latest/license.txt.
// All use of the software is governed by the License. All materials are made available on an "AS IS" BASIS, WITHOUT
// WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. Do not remove or modify any license notices.
import AnimationClipHandler from '../../animationpack/handlers/AnimationClipHandler';
import AnimationComponentHandler from '../../animationpack/handlers/AnimationComponentHandler';
import AnimationLayersHandler from '../../animationpack/handlers/AnimationLayersHandler';
import AnimationStateHandler from '../../animationpack/handlers/AnimationStateHandler';
import SkeletonHandler from '../../animationpack/handlers/SkeletonHandler';

export default {
  AnimationClipHandler,
  AnimationComponentHandler,
  AnimationLayersHandler,
  AnimationStateHandler,
  SkeletonHandler,
};
